/**
 * Sort awards by active action in the following order:
 * from left to right, the next unrevealed award or the active primary button is always visible.
 */
export default (awards, isMobile) => {
    if (!awards || awards.length < 2) return awards;

    const indexToPasteActiveAward = isMobile ? 0 : 1;

    if (awards[indexToPasteActiveAward].actionAllowed) return awards;

    const indexWithActiveAction = awards.findIndex(aw => Boolean(aw.actionAllowed));
    const awardToPasteIntoIndex = awards.splice(indexWithActiveAction, 1);
    awards.splice(indexToPasteActiveAward, 0, awardToPasteIntoIndex[0]);

    return awards;
};
